const map = {
	"./Truck_Yellow.png": 71124,
	"./caminhao_01.png": 20500,
	"./caminhao_02.png": 42959,
	"./caminhao_03.png": 74214,
	"./caminhao_04.png": 62841,
	"./caminhao_05.png": 47088,
	"./caminhao_06.png": 12491,
	"./caminhao_07.png": 48834,
	"./caminhao_08.png": 49701,
	"./caminhao_09.png": 32188,
	"./caminhao_10.png": 75346,
	"./caminhao_11.png": 90171,
	"./caminhao_12.png": 11840,
	"./caminhao_13.png": 89961,
	"./caminhao_14.png": 49878,
	"./caminhao_15.png": 63167,
	"./caminhao_16.png": 26308,
	"./caminhao_17.png": 80205,
	"./caminhao_18.png": 6074,
	"./caminhao_19.png": 70179,
	"./caminhao_20.png": 54499,
	"./caminhao_21.png": 49274,
	"./caminhao_22.png": 57585,
	"./caminhao_23.png": 17640,
	"./caminhao_24.png": 92807,
	"./caminhao_25.png": 21470,
	"./caminhao_azul.png": 68635,
	"./carreta_01.png": 67962,
	"./carreta_02.png": 44209,
	"./carreta_03.png": 95816,
	"./carreta_04.png": 75431,
	"./carreta_05.png": 99646,
	"./carreta_06.png": 20021,
	"./carro06.png": 24671,
	"./carro07.png": 70870,
	"./carro14.png": 36362,
	"./carro_01.png": 84091,
	"./carro_02.png": 5760,
	"./carro_03.png": 60585,
	"./carro_04.png": 60758,
	"./carro_05.png": 57087,
	"./carro_08.png": 42522,
	"./carro_09.png": 60099,
	"./carro_10.png": 51229,
	"./carro_11.png": 13748,
	"./carro_12.png": 35215,
	"./carro_13.png": 53670,
	"./carro_15.png": 49840,
	"./carro_16.png": 80011,
	"./carro_17.png": 89506,
	"./maquina_01.png": 70896,
	"./maquina_02.png": 42187,
	"./maquina_03.png": 21058,
	"./maquina_04.png": 8957,
	"./maquina_05.png": 92276,
	"./maquina_06.png": 66767,
	"./maquina_07.png": 27750,
	"./maquina_08.png": 62945,
	"./maquina_09.png": 41816,
	"./maquina_10.png": 36382,
	"./moto_01.png": 55805,
	"./moto_02.png": 58246,
	"./moto_03.png": 39791,
	"./moto_04.png": 70768,
	"./moto_05.png": 77017,
	"./moto_06.png": 94082,
	"./moto_07.png": 84587,
	"./onibus_01.png": 44450,
	"./onibus_02.png": 58457,
	"./onibus_03.png": 42704
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76285;